"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgScreenSleep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 57.5,
    stroke: props.color || "#133251",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "screen_Sleep_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.429 71.713C102.01 73.168 94 81.92 94 92.5c0 11.598 9.626 21 21.5 21 6.107 0 11.619-2.487 15.533-6.48C127.708 119.67 116.194 129 102.5 129 86.208 129 73 115.792 73 99.5S86.208 70 102.5 70c3.484 0 6.826.604 9.929 1.713z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.429 71.713l.692 4.952.991-9.66-1.683 4.708zm18.604 35.307l4.836 1.271 4.794-18.24-13.201 13.469 3.571 3.5zM99 92.5c0-7.962 6.048-14.708 14.121-15.835l-1.384-9.904C98.972 68.544 89 79.303 89 92.5h10zm16.5 16c-9.224 0-16.5-7.274-16.5-16H89c0 14.47 11.976 26 26.5 26v-10zm11.962-4.98c-2.999 3.06-7.235 4.98-11.962 4.98v10c7.487 0 14.275-3.054 19.104-7.981l-7.142-6.999zm-1.265 2.229C123.436 116.256 113.866 124 102.5 124v10c16.022 0 29.481-10.917 33.369-25.709l-9.672-2.542zM102.5 124C88.969 124 78 113.031 78 99.5H68c0 19.054 15.446 34.5 34.5 34.5v-10zM78 99.5C78 85.969 88.969 75 102.5 75V65C83.446 65 68 80.446 68 99.5h10zM102.5 75c2.902 0 5.676.502 8.246 1.421l3.366-9.417A34.452 34.452 0 00102.5 65v10z",
    fill: props.color || "#133251",
    mask: "url(#screen_Sleep_svg__a)"
  }));
}

var _default = SvgScreenSleep;
exports["default"] = _default;